export default __webpack_public_path__ + "static/media/icons-16.13933033.ttf";